<template>
  <div :class="$style['wrapper']">
    <div :class="$style['section-info']">
      <div :class="$style['section-info__header']">
        <div :class="$style['section-info__header-right']">
          <img :src="logo">
          {{ $t('landing.logoText') }}
        </div>

        <div :class="$style['section-info__header-left']">
          <router-link to="/login" :class="$style['section-info__header-help']">
            <img :src="question" width="14"> {{ $t('landing.help') }}
          </router-link>
          <div :class="$style['section-info__header-lang']">
            <div :data-active="locale === 'kk'" @click="locale = 'kk'">ҚАЗ</div>
            <div :data-active="locale === 'ru'" @click="locale = 'ru'">РУС</div>
          </div>
        </div>
      </div>

      <div :class="$style['section-info__content']">
        <div :class="$style['section-info__content-title']">
          <img :src="logoNodb" width="103" height="103">

          <span>{{ $t('landing.info.title') }}</span>
        </div>
        <div :class="$style['section-info__content-description']">
          {{ $t('landing.info.description') }}
        </div>
        <div :class="$style['section-info__content-btns']">
          <router-link to="/login">
            <img :src="loginIcon" width="32" height="17">
            {{ $t('landing.info.login') }}
          </router-link>
          <router-link to="/login">
            <img :src="registerIcon" width="32" height="22">
            {{ $t('landing.info.register') }}
          </router-link>
        </div>

        <img :src="map" :class="$style['section-info__content-map']">
      </div>
    </div>

    <img :src="rectangle1" :class="$style['section-info__rectangle-1']" height="830">
    <img :src="rectangle2" :class="$style['section-info__rectangle-2']" height="160">
    <img :src="rectangle3" :class="$style['section-info__rectangle-3']" height="500">
    <img :src="rectangle4" :class="$style['section-info__rectangle-4']" height="280">

    <div :class="$style['section-stats']">
      <div :class="$style['heading']">
        <span>{{ $t('landing.stats.title') }}</span>
      </div>

      <div :class="$style['section-stats__list']">
        <div v-for="stat in stats" :key="stat.text" :class="$style['section-stats__item-bg']">
          <div :class="$style['section-stats__item-content']">
            <div>{{ stat.value }}</div>
            <div>{{ stat.ext }}</div>
            <div>{{ stat.text }}</div>
          </div>
        </div>
      </div>

      <router-link to="/login" :class="$style['section-stats__btn']">
        {{ $t('landing.stats.btn') }}
      </router-link>
    </div>

    <div :class="$style['section-modules']">
      <div :class="$style['heading']">
        <span>{{ $t('landing.modules.title') }}</span>
      </div>

      <div :class="$style['section-modules__list']">
        <div v-for="module in modules" :key="module.text" :class="$style['section-modules__item']">
          <div>
            <img :src="module.icon">
          </div>
          <div>НОБД</div>
          <div :class="module.textSmall && $style['section-modules__item-small']">
            {{ module.text }}
          </div>
          <router-link to="/login">
            {{ $t('landing.modules.btn') }} <img :src="arrowRight" height="15">
          </router-link>
        </div>
      </div>
    </div>

    <div :class="$style['footer']">
      <div :class="$style['footer__content']">
        <div :class="$style['footer__header']">
          <div :class="$style['footer__header-logo']">
            <img :src="logo">
            {{ $t('landing.logoText') }}
          </div>

          <div :class="$style['footer__header-data']">
            <div>{{ $t('landing.footer.email') }}:</div>
            <a href="mailto:support_nobd@edu.kz">support_nobd@edu.kz</a>
          </div>

          <div :class="$style['footer__header-data']">
            <div>{{ $t('landing.footer.phone') }}:</div>
            <a href="tel:+77172578629">+7 7172 578 629</a>
          </div>
        </div>

        <div>© {{ $t('landing.footer.description') }}, {{ new Date().getFullYear() }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from '@/assets/icons/landing-logo.svg'
import logoNodb from '@/assets/icons/nodb-logo.svg'
import loginIcon from '@/assets/icons/landing-login-icon.svg'
import registerIcon from '@/assets/icons/landing-register-icon.svg'
import map from '@/assets/icons/landing-map.svg'
import rectangle1 from '@/assets/icons/landing-rectangle-1.svg'
import rectangle2 from '@/assets/icons/landing-rectangle-2.svg'
import rectangle3 from '@/assets/icons/landing-rectangle-3.svg'
import rectangle4 from '@/assets/icons/landing-rectangle-4.svg'
import portfolio from '@/assets/icons/landing-portfolio.svg'
import work from '@/assets/icons/landing-work.svg'
import automatization from '@/assets/icons/landing-automatization.svg'
import union from '@/assets/icons/landing-union.svg'
import dashboard from '@/assets/icons/landing-dashboard.svg'
import verification from '@/assets/icons/landing-verification.svg'
import arrowRight from '@/assets/icons/landing-arrow-right.svg'
import question from '@/assets/icons/landing-question.svg'
import {useI18n} from 'vue-i18n'
import {computed} from 'vue'

const {t, locale} = useI18n()

const stats = computed(() => [
  {
    value: '21',
    ext: t('landing.stats.thousand'),
    text: t('landing.stats.organizations'),
  },
  {
    value: '5,5',
    ext: t('landing.stats.million'),
    text: t('landing.stats.learners'),
  },
  {
    value: '1',
    ext: t('landing.stats.million'),
    text: t('landing.stats.teachers'),
  },
])

const modules = computed(() => [
  {
    icon: portfolio,
    text: t('landing.modules.portfolio'),
  },
  {
    icon: work,
    text: t('landing.modules.work'),
  },
  {
    icon: automatization,
    text: t('landing.modules.automatization'),
    textSmall: true,
  },
  {
    icon: union,
    text: t('landing.modules.union'),
  },
  {
    icon: dashboard,
    text: t('landing.modules.dashboard'),
  },
  {
    icon: verification,
    text: t('landing.modules.verification'),
  },
])
</script>

<style lang="scss" module>
.wrapper {
  font-family: var(--landing-font-family);
  background-color: var(--landing-bg);
  color: var(--landing-text);
}
.section-info {
  position: relative;

  min-height: 920px;
  max-width: 1684px;
  width: 100%;
  margin: 0 auto;
  padding: 76px 118px;

  overflow: hidden;

  &__header {
    display: flex;
    justify-content: space-between;

    &-right {
      display: flex;
      align-items: center;
      column-gap: 20px;

      font-size: 18px;
      font-weight: 700;
      color: var(--landing-brand-dark);
      white-space: pre-line;
    }
    &-left {
      display: flex;
      align-items: center;
      column-gap: 45px;
    }
    &-help {
      display: flex;
      align-items: center;
      column-gap: 8px;

      color: var(--landing-brand-blue);
      text-decoration: none;
    }
    &-lang {
      display: flex;

      color: var(--landing-brand-light-blue);
      background-color: var(--landing-bg);
      border: 1px solid var(--landing-brand-light-blue);
      border-radius: 5px;
      overflow: hidden;

      div {
        padding: 10px 17px;

        cursor: pointer;

        &[data-active='true'] {
          background-color: var(--landing-brand-blue);
          color: var(--landing-bg);
        }
      }
    }
  }
  &__content {
    position: relative;

    margin-top: 105px;

    &-title {
      max-width: 50%;

      display: flex;
      column-gap: 28px;

      font-size: 44px;
      font-weight: 600;
      color: var(--landing-brand-dark);
      white-space: pre-line;
      text-transform: uppercase;

      > span {
        max-width: 500px;
      }
    }
    &-description {
      margin: 52px 0 80px;
      max-width: 600px;

      font-size: 28px;
    }
    &-btns {
      display: flex;
      column-gap: 32px;

      > a {
        position: relative;

        width: 274px;
        height: 60px;
        padding-left: 32px;

        display: flex;
        align-items: center;
        justify-content: center;

        border-radius: 5px;
        font-size: 24px;
        font-weight: 600;
        text-decoration: none;

        &:first-child {
          color: var(--landing-bg);
          background-color: var(--landing-brand-blue);
        }
        &:last-child {
          color: var(--landing-brand-blue);
          border: 1px solid var(--landing-brand-blue);
        }

        img {
          position: absolute;
          left: 17px;
          top: 50%;

          transform: translateY(-50%);
        }
      }
    }
    &-map {
      position: absolute;
      right: -70px;
      top: 48%;
      z-index: -1;

      width: 1015px;
      max-width: 70%;

      transform: translateY(-50%);
    }
  }
  &__rectangle-1 {
    position: absolute;
    right: 0;
    top: 20px;
    z-index: -2;
  }
  &__rectangle-2 {
    position: absolute;
    right: 44vw;
    top: 0;
    z-index: -2;

    transform: translateX(50%);
  }
  &__rectangle-3 {
    position: absolute;
    right: 42vw;
    top: 0;
    z-index: -3;

    transform: translateX(50%);
  }
  &__rectangle-4 {
    position: absolute;
    right: 63vw;
    top: 0;
    z-index: -5;

    transform: translateX(50%);
  }
}
.heading {
  position: relative;

  text-align: center;

  &:before {
    content: '';
    position: absolute;
    right: 0;
    left: 0;
    top: 50%;
    z-index: -1;

    height: 1px;
    background-color: var(--landing-brand-blue);
  }

  > span {
    padding: 0 36px;

    font-size: 38px;
    font-weight: 600;
    color: var(--landing-brand-dark);
    text-transform: uppercase;
    background-color: var(--landing-bg);
  }
}
.section-stats {
  max-width: 1684px;
  width: 100%;
  margin: 0 auto;
  padding: 0 118px;

  &__list {
    margin-top: 80px;

    display: flex;
    justify-content: center;
    column-gap: 24px;
  }
  &__item {
    &-bg {
      background-color: var(--landing-stat-bg);

      width: 317px;
      height: 317px;
      padding: 20px;

      display: flex;

      border-radius: 50%;
    }
    &-content {
      flex: 1;

      box-shadow: 0 0 17px var(--landing-stat-shadow);
      background-color: var(--landing-bg);
      border-radius: 50%;

      text-align: center;

      div:nth-child(1) {
        font-size: 80px;
        font-weight: 700;
        color: var(--landing-brand-dark);
      }
      div:nth-child(2) {
        font-size: 28px;
        line-height: 1;
        font-weight: 600;
        color: var(--landing-brand-dark);
      }
      div:nth-child(3) {
        height: 100px;
        margin-top: 22px;

        font-size: 24px;
      }
    }
  }
  &__btn {
    height: 42px;
    width: 218px;
    margin: 54px auto 84px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--landing-bg);
    background-color: var(--landing-brand-blue);
    border-radius: 5px;
    text-decoration: none;
  }
}
.section-modules {
  max-width: 1684px;
  width: 100%;
  margin: 0 auto;
  padding: 0 118px;

  &__list {
    margin: 46px auto 150px;

    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    row-gap: 44px;
    column-gap: 44px;
  }
  &__item {
    width: 326px;
    padding: 20px 15px 0;

    display: flex;
    flex-flow: column wrap;
    align-items: center;

    background-color: var(--landing-bg);
    border-radius: 10px;
    box-shadow: 0 5px 29px var(--landing-card-shadow);

    &-small {
      font-size: 17px !important;
    }

    div img:nth-child(1) {
      width: 50px;
    }
    div:nth-child(2) {
      margin: 6px auto 0;
      color: var(--landing-text-muted);
      font-size: 14px;
    }
    div:nth-child(3) {
      height: 52px;
      margin-top: 14px;

      font-size: 19px;
      font-weight: 600;
      text-align: center;
      text-transform: uppercase;
      white-space: pre-line;
    }
    a:nth-child(4) {
      margin: 10px auto 0;
      height: 52px;
      width: calc(100% - 10px);

      column-gap: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      color: var(--landing-text-dark);
      font-size: 18px;
      border-top: 1px solid var(--landing-border-light);
      text-decoration: none;
    }
  }
}
.footer {
  background-color: var(--landing-footer-bg);

  &__content {
    max-width: 1684px;
    padding: 40px 118px;
    margin: 0 auto;

    color: var(--landing-footer-text);
  }
  &__header {
    margin-bottom: 45px;

    display: flex;
    column-gap: 100px;

    &-logo {
      display: flex;
      align-items: center;
      column-gap: 12px;

      font-size: 15px;
      font-weight: 500;
      color: var(--landing-footer-text);
      white-space: pre-line;
    }
    &-data {
      display: flex;
      flex-flow: column;
      justify-content: center;

      div:nth-child(1) {
        margin-bottom: 3px;

        font-size: 14px;
      }
      a:nth-child(2) {
        color: var(--landing-footer-text);
        font-weight: 600;
        text-decoration: none;
      }
    }
  }
}
</style>
